import { gql } from '@parkchirp/api-client';

export const CREATE_ORGANIZATION = gql`
  mutation createOrganization($name: String!) {
    createOrganization(name: $name)
  }
`;
